import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../SidebarItem";

import {ReactComponent as MessageIcon} from "assets/img/message.svg";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

import {SidebarContext} from "../../../../../../SidebarContext";

function PersonalShopperItem(props) {
    const {currentPath, currentMemberAuthorizations} = useContext(SidebarContext);

    if (!hasAuthorization(currentMemberAuthorizations, Authorizations.PERSONALSHOPPER_MANAGEMENT)) {
        return null;
    }

    return (
        <SidebarItem
            isTopLevel
            icon={<MessageIcon />}
            to={MarketplaceRoutes.PERSONAL_SHOPPER}
            selected={currentPath.startsWith(MarketplaceRoutes.PERSONAL_SHOPPER)}
        >
            <FormattedMessage id='sidebar.item.personalShopper' />
        </SidebarItem>
    );
}

export default PersonalShopperItem;
